import React from "react";
const StatsContext = React.createContext(null);
export default StatsContext;
